import React, { useEffect, useState } from "react";
import {
    FaFire,
    FaBitcoin,
    FaEthereum,
    FaDollarSign,
    FaChartLine,
    FaHeart,
    FaComment,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import SignalsService from "../../../services/Signals";



const signals = [
    {
        id: 1,
        icon: <FaFire className="text-xl text-white" />,
        bg: "from-red-500 to-orange-500",
        pair: "EUR/USD",
        type: "SELL",
        typeColor: "bg-red-100 text-red-700",
        package: "Golden Package",
        author: "Ahmad Rezaei",
        likes: 89,
        comments: 34,
        profit: "+2.1%",
        time: "2 hours ago",
    },
    {
        id: 2,
        icon: <FaBitcoin className="text-xl text-white" />,
        bg: "from-blue-500 to-purple-500",
        pair: "BTC/USDT",
        type: "BUY",
        typeColor: "bg-green-100 text-green-700",
        package: "Silver Strategy",
        author: "Maryam Ahmadi",
        likes: 156,
        comments: 67,
        profit: "+4.3%",
        time: "1 hour ago",
    },
    {
        id: 3,
        icon: <FaEthereum className="text-xl text-white" />,
        bg: "from-green-500 to-emerald-500",
        pair: "ETH/USDT",
        type: "BUY",
        typeColor: "bg-green-100 text-green-700",
        package: "Platinum Package",
        author: "Ali Mohammadi",
        likes: 203,
        comments: 89,
        profit: "+3.7%",
        time: "3 hours ago",
    },
    {
        id: 4,
        icon: <FaDollarSign className="text-xl text-white" />,
        bg: "from-yellow-500 to-orange-500",
        pair: "GBP/USD",
        type: "SELL",
        typeColor: "bg-red-100 text-red-700",
        package: "Scalping Strategy",
        author: "Sara Karimi",
        likes: 124,
        comments: 45,
        profit: "+1.8%",
        time: "5 hours ago",
    },
    {
        id: 5,
        icon: <FaChartLine className="text-xl text-white" />,
        bg: "from-purple-500 to-pink-500",
        pair: "USD/JPY",
        type: "BUY",
        typeColor: "bg-green-100 text-green-700",
        package: "Gold Package",
        author: "Keyvan Abbasi",
        likes: 78,
        comments: 23,
        profit: "+2.9%",
        time: "6 hours ago",
    },
];

export default function Targeted() {

    const getPackageIcon = (pkg) => {
        const name = pkg?.name?.toLowerCase() || '';

        if (name.includes('Golden')
            //  || name.includes('') || name.includes('')
        ) {
            return {
                icon: <FaFire className="text-3xl text-white" />,
                bgColor: "bg-gradient-to-br from-amber-50 to-orange-50",
                bgIcon: "bg-gradient-to-br from-amber-400 to-orange-500",
                bgLabel: "bg-amber-500",
                bgSpan: "bg-amber-200/20"
            };
        }
        if (name.includes('Bitcoin')
            //  || name.includes('') || name.includes('')
        ) {
            return {
                icon: <FaBitcoin className="text-3xl text-white" />,
                bgColor: "bg-gradient-to-br from-blue-50 to-indigo-50",
                bgIcon: "bg-gradient-to-br from-blue-400 to-indigo-500",
                bgLabel: "bg-rose-500",
                bgSpan: "bg-blue-200/20"
            };
        }
        if (name.includes('Platinum')
            //  || name.includes('') || name.includes('')
        ) {
            return {
                icon: <FaEthereum className="text-3xl text-white" />,
                bgColor: "bg-gradient-to-br from-purple-50 to-pink-50",
                bgIcon: "bg-gradient-to-br from-purple-400 to-pink-500",
                bgLabel: "bg-purple-500",
                bgSpan: "bg-purple-200/20"
            };
        }
        if (name.includes('Scalping')
            //  || name.includes('') || name.includes('')
        ) {
            return {
                icon: <FaDollarSign className="text-3xl text-white" />,
                bgColor: "bg-gradient-to-br from-emerald-50 to-teal-50",
                bgIcon: "bg-gradient-to-br from-emerald-400 to-teal-500",
                bgLabel: "bg-emerald-500",
                bgSpan: "bg-emerald-200/20"
            };
        }

        if (name.includes('Scalping')
            //  || name.includes('') || name.includes('')
        ) {
            return {
                icon: <FaChartLine className="text-3xl text-white" />,
                bgColor: "bg-gradient-to-br from-emerald-50 to-teal-50",
                bgIcon: "bg-gradient-to-br from-emerald-400 to-teal-500",
                bgLabel: "bg-emerald-500",
                bgSpan: "bg-emerald-200/20"
            };
        }
        // return {
        //     icon: <FaChartLine className="text-3xl text-white" />,
        //     bgColor: "bg-gradient-to-br from-gray-50 to-gray-50",
        //     bgIcon: "bg-gradient-to-br from-gray-400 to-gray-500",
        //     bgLabel: "bg-gray-500",
        //     bgSpan: "bg-gray-200/20"
        // };
    };


    const navigate = useNavigate(); // ← هوک ناوبری

    const [signals2, setSignals] = useState([]);
    
    useEffect(() => {
        const fetchSignals = async () => {
            try {
                const response = await SignalsService.getAll();
                setSignals(response?.data?.data);
                // console.log("Targeted Signals:", response?.data?.data);
                // در اینجا می‌توانید داده‌ها را در حالت محلی ذخیره کنید
            } catch (error) {
                console.error("Error fetching targeted signals:", error);
            }
        };

        fetchSignals();
    }, []);

    return (
        <section id="targeted" className="py-6">
            <div className="px-4 mb-4 flex items-center justify-between">
                <h2 className="text-xl font-bold">🎯 Targeted</h2>
                <button className="text-sm text-gray-600">View All</button>
            </div>

            <div className="px-4 space-y-3">
                {signals.map((signal) => (

                    <div
                        key={signal.id}
                        // onClick={() => navigate(`/signal/${signal.id}`)}
                        //uncomment onclick when the get targeted signal api is fixed -MM*
                        className="bg-white rounded-2xl shadow-sm border border-gray-100 p-4 cursor-pointer">
                        <div className="flex items-start justify-between mb-3">
                            <div className="flex items-center space-x-3">
                                <div className={`bg-gradient-to-br ${signal.bg} h-14 w-14 rounded-xl flex items-center justify-center flex-shrink-0`}>
                                    {signal.icon}
                                </div>
                                <div>
                                    <div className="flex items-center space-x-2 mb-1">
                                        <h3 className="font-bold text-gray-900 text-lg">{signal.pair}</h3>
                                        <span className={`text-xs ${signal.typeColor} px-2.5 py-1 rounded-full font-semibold`}>{signal.type}</span>
                                    </div>
                                    <p className="text-sm text-gray-600 font-medium">{signal.package}</p>
                                    <p className="text-xs text-gray-500">by {signal.author}</p>
                                </div>
                            </div>
                            <div className="text-right">
                                <span className="inline-block bg-gray-100 text-gray-700 text-xs font-semibold px-3 py-1.5 rounded-full">Closed</span>
                            </div>
                        </div>

                        <div className="grid grid-cols-3 gap-3 mb-3">
                            <div className="bg-gray-50 rounded-lg p-2.5">
                                <p className="text-xs text-gray-500 mb-1">Entry Price</p>
                                <p className="font-bold text-gray-900">43,250</p>
                            </div>
                            <div className="bg-gray-50 rounded-lg p-2.5">
                                <p className="text-xs text-gray-500 mb-1">Target Hit</p>
                                <p className="font-bold text-emerald-600">3/3</p>
                            </div>
                            <div className="bg-gray-50 rounded-lg p-2.5">
                                <p className="text-xs text-gray-500 mb-1">Profit</p>
                                <p className="font-bold text-emerald-600">+4.3%</p>
                            </div>
                        </div>

                        <div className="flex items-center justify-between pt-3 border-t border-gray-100">
                            <div className="flex items-center space-x-3">
                                <div className="flex items-center space-x-1.5">
                                    <FaHeart className="text-gray-400 text-xs" />
                                    <span className="text-xs text-gray-600">{signal.likes}</span>
                                </div>
                                <div className="flex items-center space-x-1.5">
                                    <FaComment className="text-gray-400 text-xs" />
                                    <span className="text-xs text-gray-600">
                                        {signal.comments}
                                    </span>
                                </div>
                            </div>
                            <p className="text-xs text-gray-400">1 hour ago</p>
                        </div>
                    </div>


                    // <div
                    //     key={signal.id}
                    //     onClick={() => navigate(`/signal/${signal.id}`)}
                    //     className="flex items-center gap-4 p-4 bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow border border-gray-100 cursor-pointer"
                    // >
                    //     <div
                    //         className={`bg-gradient-to-br ${signal.bg} h-12 w-12 rounded-lg flex items-center justify-center flex-shrink-0`}
                    //     >
                    //         {signal.icon}
                    //     </div>

                    //     <div className="flex-grow">
                    //         <div className="flex items-center space-x-2 mb-1">
                    //             <h3 className="font-semibold text-gray-900">{signal.pair}</h3>
                    //             <span
                    //                 className={`text-xs px-2 py-1 rounded-full font-medium ${signal.typeColor}`}
                    //             >
                    //                 {signal.type}
                    //             </span>
                    //         </div>
                    //         <p className="text-sm text-gray-600 font-medium">
                    //             {signal.package}
                    //         </p>
                    //         <p className="text-sm text-gray-500">by {signal.author}</p>
                    //         <div className="flex items-center space-x-3 mt-1">
                    //             <div className="flex items-center space-x-1">
                    //                 <FaHeart className="text-gray-400 text-xs" />
                    //                 <span className="text-xs text-gray-600">{signal.likes}</span>
                    //             </div>
                    //             <div className="flex items-center space-x-1">
                    //                 <FaComment className="text-gray-400 text-xs" />
                    //                 <span className="text-xs text-gray-600">
                    //                     {signal.comments}
                    //                 </span>
                    //             </div>
                    //         </div>
                    //     </div>

                    //     <div className="text-right">
                    //         <p className="font-semibold text-green-600">{signal.profit}</p>
                    //         <p className="text-xs text-gray-400">{signal.time}</p>
                    //     </div>
                    // </div>
                ))}
            </div>
        </section>
    );
}
